/** Chat bubble + red count — beside queue/case number when patient messages are unread. */
export function CaseChatUnreadBadge({
  unread,
  className = '',
}: {
  unread: number;
  className?: string;
}) {
  if (unread <= 0) return null;

  const label = `${unread} unread patient message${unread === 1 ? '' : 's'}`;

  return (
    <span
      className={`case-chat-unread ${className}`.trim()}
      aria-label={label}
      title={label}
    >
      <svg className="case-chat-unread__icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
        <path
          fillRule="evenodd"
          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
          clipRule="evenodd"
        />
      </svg>
      <span className="case-chat-unread__count">{unread > 9 ? '9+' : unread}</span>
    </span>
  );
}
